import React from 'react';
import { Container, Source, TooltipText } from './styles';

interface ITooltipProps {
  children: React.ReactNode;
  text: string;
}

const Tooltip: React.FC<ITooltipProps> = ({ children, text }) => {
  return (
    <Container>
      <Source>{children}</Source>
      <TooltipText>{text}</TooltipText>
    </Container>
  );
};

export default React.memo(Tooltip);
